var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44378 2.84449L13.0081 12.4088",
    stroke: "#1A1B1D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9785 8.03312L10.9785 6.87695L9.89614 6.87695L10.9785 8.03312ZM7.8414 6.87695L5.47253 6.87695L5.47253 8.37695L9.24566 8.37695L7.8414 6.87695Z",
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3205 10.2893C14.0089 9.6295 14.4375 8.70078 14.4375 7.67196C14.4375 5.66997 12.8146 4.04704 10.8126 4.04704L8.75906 4.04704L8.75906 5.54704L10.8126 5.54704C11.9861 5.54704 12.9375 6.49839 12.9375 7.67196C12.9375 8.29573 12.6687 8.85673 12.2407 9.24546L13.3205 10.2893ZM10.8126 9.95125L10.8126 11.2969C11.2281 11.2969 11.6273 11.227 11.9991 11.0982L10.8126 9.95125Z",
    fill: "#1A1B1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47328 4.79785H5.06258C3.47481 4.79785 2.18766 6.085 2.18766 7.67277V7.67277C2.18766 9.26055 3.47481 10.5477 5.06258 10.5477H7.9375",
    stroke: "#1A1B1D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlink);
export default __webpack_public_path__ + "static/media/unlink.1b869b607d7a1c4ab9616484cd2997b5.svg";
export { ForwardRef as ReactComponent };